import { XmlApi } from '../../infrastructure/api';

export class UploadXmlUseCase {
    async execute(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: ProgressEvent<FileReader>) => {
                try {
                    const xmlContent = e.target?.result as string;
                    if (!xmlContent) {
                        reject(new Error('Failed to read file'));
                        return;
                    }
                    resolve(xmlContent);
                } catch (error) {
                    reject(error);
                }
            };

            reader.onerror = () => {
                reject(new Error('Error reading file'));
            };

            reader.readAsText(file);
        });
    }

    async uploadToTransaction(
        transactionId: number,
        xmlContent: string,
        token: string
    ): Promise<void> {
        const success = await XmlApi.upload(transactionId, xmlContent, token);
        if (!success) {
            throw new Error('Failed to upload XML');
        }
    }
}

